import { API_URL } from '../config/api';

const AUTH_EMAIL_KEY = 'auth_email';
const AUTH_ROLE_KEY = 'auth_role';

export const login = async (email, password) => {
    const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
        throw new Error('Neplatné přihlašovací údaje');
    }

    // The JWT is set as an httpOnly cookie by the server and never touches JS.
    // The response body contains only { email, role } for UI purposes.
    const data = await response.json();
    setAuth(data);
    return data;
};

export const register = async (email, password) => {
    const response = await fetch(`${API_URL}/auth/register`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || 'Registrace se nezdařila');
    }
    const data = await response.json();
    setAuth(data);
    return data;
};

export const requestPasswordReset = async (email) => {
    const response = await fetch(`${API_URL}/auth/password-reset/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
    });
    if (!response.ok) {
        throw new Error('Požadavek se nezdařil');
    }
};

export const confirmPasswordReset = async (token, newPassword) => {
    const response = await fetch(`${API_URL}/auth/password-reset/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
    });
    if (response.status === 401) {
        throw new Error('invalid_token');
    }
    if (!response.ok) {
        throw new Error('Změna hesla se nezdařila');
    }
};

export const loginWithGoogle = async (credential) => {
    const response = await fetch(`${API_URL}/auth/google`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credential }),
    });
    if (!response.ok) {
        throw new Error('Přihlášení přes Google se nezdařilo');
    }
    const data = await response.json();
    setAuth(data);
    return data;
};

// Asks the server to clear the auth cookie (maxAge=0) and wipes local UI state.
export const logout = async () => {
    await fetch(`${API_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
    }).catch(() => {});
    clearAuth();
};

// Stores only email and role — the JWT itself is an httpOnly cookie managed by the browser.
export const setAuth = ({ email, role }) => {
    if (email) localStorage.setItem(AUTH_EMAIL_KEY, email);
    if (role) localStorage.setItem(AUTH_ROLE_KEY, role);
};

export const clearAuth = () => {
    localStorage.removeItem(AUTH_EMAIL_KEY);
    localStorage.removeItem(AUTH_ROLE_KEY);
};

export const getEmail = () => localStorage.getItem(AUTH_EMAIL_KEY);

export const getRole = () => localStorage.getItem(AUTH_ROLE_KEY);

// Lightweight UI check — real auth is enforced server-side via the cookie.
// Components/services use this only to skip pointless API calls when clearly logged out.
export const isLoggedIn = () => !!localStorage.getItem(AUTH_EMAIL_KEY);

// Kept for backward compatibility — browser sends the httpOnly cookie automatically,
// so no Authorization header is needed from JS code.
export const getAuthHeaders = () => ({});
